
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { paginationChange, Ticket_Statuses, TicketStatus } from '@common/interfaces';
import { FIELD_ARRAY_APPROVAL_LIST, FIELD_ARRAY_CLIENTS_LIST, FIELD_ARRAY_FOR_CLOSED_TICKETS, FIELD_ARRAY_PROJECTS_LIST, FIELD_ARRAY_TICKET_LIST, FIELD_ARRAY_WORKSPACE_LIST } from 'libs/common/src/lib/constants/table-field-constants';
@Component({
  selector: 'app-table-list',
  templateUrl: './table-list.component.html',
  styleUrls: ['./table-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableListComponent {
  private _fieldArray!: Array<{ fieldName: string, type: string, keyType: string, key: any, icon: string }>;

  @Input()
  set fieldArray(value: Array<{ fieldName: string, type: string, keyType: string, key: any, icon: string }>) {
    this._fieldArray = value;
    this.HeadArray = value.map(f => f.fieldName);
    this.cdr.markForCheck(); // Tell Angular to check for changes
  }
  get fieldArray() {
    return this._fieldArray;
  }

  HeadArray: string[] = [];

  @Input() dataSource!: any[];
  @Input() approvalStatus!: boolean;
  @Input() projectStatus!: boolean;
  @Input() workspaceStatus!: boolean;
  @Input() clientStatus!: boolean;
  @Output() clickEvent = new EventEmitter<string>()
  @Output() clickOnSort = new EventEmitter<string>();
  @Output() editProject = new EventEmitter<any>();
  @Output() deleteProject = new EventEmitter<any>();
  @Output() editClient = new EventEmitter<any>();
  @Output() deleteClient = new EventEmitter<any>();
  descendingSortIcon = `assets/12x12/sort-asc.svg`;
  ascendingSortIcon = `assets/12x12/sort-desc.svg`;
  currentSortOrder = 'DESC';
  sortIcons = [{ typeOfOrder: 'DESC', icon: `assets/12x12/sort-asc.svg` }, { typeOfOrder: 'ASC', icon: 'assets/12x12/sort-desc.svg' }]
  imageAddress = this.sortIcons[0].icon;
  hasDate: boolean = false;
  previousDate!: string;
  previousClient:string|null=null;
  canClientBeShown: boolean = false;
  isClosedCardSelected: boolean = false;
  canDateBeShown: boolean = false;
  placeholderTitle = 'No tickets generated yet';
  placeholderSubtitle =
    'Once you start generating tickets, they will appear here';
  placeholderIcon = 'assets/58x58/no_tickets.svg';
  constructor(private cdr: ChangeDetectorRef, private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.previousClient = null;
    if (changes['dataSource']) {
      this.previousDate = '';
      this.dataSource = this.dataSource;
    }
    if (changes['fieldArray']) {
      this.cdr.detectChanges()
    }
    if (changes['approvalStatus']) {
      this.updateFieldArray(this.activatedRoute.snapshot.queryParams)
    }
  }
  sortProjectsByClient() {
  this.dataSource.sort((a, b) => {
    const clientA = a.clientName.toLowerCase();
    const clientB = b.clientName.toLowerCase();

    if (clientA < clientB) return -1;
    if (clientA > clientB) return 1;

    // If clients are same, you can sort by project name or createdOn if needed
    const projectA = a.name.toLowerCase();
    const projectB = b.name.toLowerCase();

    if (projectA < projectB) return -1;
    if (projectA > projectB) return 1;

    return 0;
  });
}
  ngOnInit(): void {
    this.previousClient = ''
    this.previousDate = ''
    this.activatedRoute.queryParams.subscribe((params) => {
      this.updateFieldArray(params)
    })
  }
  updateFieldArray(params: any) {
    if (this.approvalStatus) {
      this.fieldArray = FIELD_ARRAY_APPROVAL_LIST;
    } else if (this.workspaceStatus) {
      this.fieldArray = FIELD_ARRAY_WORKSPACE_LIST;
    }else if(this.clientStatus){
      this.fieldArray = FIELD_ARRAY_CLIENTS_LIST;
    } else if (this.projectStatus) {
      this.fieldArray = FIELD_ARRAY_PROJECTS_LIST;
    }
    else {
      switch (params['status']) {
        case 'CLOSED':
          this.placeholderTitle = 'No Closed Tickets';
          this.placeholderSubtitle = 'There are no closed tickets';
          break;
        case 'TO_DO':
          this.placeholderTitle = 'No To-DO Tickets';
          this.placeholderSubtitle = 'There are no To-Do tickets';
          break;
        case 'ONGOING':
          this.placeholderTitle = 'No Ongoing Tickets';
          this.placeholderSubtitle = 'There are no ongoing tickets';
          break;
        case 'ON_HOLD':
          this.placeholderTitle = 'No On-HOLD Tickets';
          this.placeholderSubtitle = 'There are no On-Hold tickets';
          break;
        case 'EXTERNAL':
          this.placeholderTitle = 'No External Tickets';
          this.placeholderSubtitle = 'There are no external tickets';
          break;
        case 'ALL':
          this.placeholderTitle = 'No tickets generated yet';
          this.placeholderSubtitle =
            'Once you start generating tickets, they will appear here';
          break;
      }
      if (params['status'] === 'CLOSED') {
        this.fieldArray = FIELD_ARRAY_FOR_CLOSED_TICKETS;
        this.HeadArray = this.fieldArray.map((r: { fieldName: any; }) => r.fieldName);
        this.isClosedCardSelected = true;
      }
      else {
        this.fieldArray = FIELD_ARRAY_TICKET_LIST;
        this.HeadArray = this.fieldArray.map((r: { fieldName: any; }) => r.fieldName);
        this.isClosedCardSelected = false;
      }
    }
    paginationChange.subscribe((res) => {

      this.previousDate = '';
      this.cdr.detectChanges();
    })
  }
  getImageAddress(field: any) {
    if (field?.icon === 'DESC') {
      return this.descendingSortIcon;
    }
    else if (field?.icon === 'ASC') {
      return this.ascendingSortIcon;
    }
    return ' '
  }
  getApproversList(element: { approvers?: any }): string {
    if (Array.isArray(element.approvers)) {
      return element.approvers
        .map((a: { firstName: string; lastName: string }) => `${a.firstName} ${a.lastName}`)
        .join(', ');
    }
    return '-';
  }
  handleProjectEdit(element: any) {
    this.editProject.emit(element);
  }
  handleProjectDelete(element: any) {
    this.deleteProject.emit(element)
  }
  handleClientEdit(element: any) {
    this.editClient.emit(element);
  }
  handleClientDelete(element: any) {
    this.deleteClient.emit(element)
  }
  getStatus(status: TicketStatus) {
    return Ticket_Statuses[status as keyof typeof Ticket_Statuses].status
  }
  getName(element: any) {
    return element?.AssetName;
  }
  getTicketNum(element: any) {
    return element
  }
  getDateForTicketRow(fieldName: string, currentTicketDate: string) {
    if (fieldName === 'Date') {
      const currentDateOnly = new Date(currentTicketDate).toDateString();
      if (!this.previousDate) {
        this.previousDate = currentDateOnly;
        this.canDateBeShown = true;
        return currentDateOnly;
      } else if (this.previousDate === currentDateOnly) {
        this.canDateBeShown = false;
        return '';
      } else {
        this.previousDate = currentDateOnly;
        this.canDateBeShown = true;
        return currentDateOnly;
      }
    }
    return '';
  }
  getPriorityClass(priority: string) {
    switch (priority) {
      case 'High':
        return 'high';
      case 'Medium':
        return 'medium';
      case 'Low':
        return 'low';
      default:
        return '';
    }
  }
   getClientForProjectRow(fieldName: string, currentClient: string) {
    if (fieldName === 'Client') {
      if (this.previousClient !== currentClient) {
      this.previousClient = currentClient;
      return currentClient;
    }
    return '';
  }
  return '';
  }
  resetClientTracker(){
    this.previousClient = null;
  }
  handleClick(ticketId: string) {
    this.clickEvent.emit(ticketId);
  }
  sortAction(field: any) {
    this.fieldArray.forEach(f => {
    if (f !== field) {
      f.icon = 'DESC'; 
    }
  });
    if (field?.icon === 'DESC') {
      field.icon = 'ASC';
    } else {
      field.icon = 'DESC';
    }
    const res = field?.fieldName.split(" ").join("");
    this.clickOnSort.emit(field.icon + ' ' + res);
  }
  getClass(element: string, key: string) {
    if (element === 'Date') {
      if (key == this.previousDate) {
        return false;
      }
      return true;
    }
    if (element === 'Day') {
      let ab;
      if (key === this.previousDate) {
        ab = true;
        return ab;
      }
      else {
        ab = false;
        return ab;
      }

    }
    return false;
  }
  convertToValidDate(dateString: string): Date | string {
    if (!dateString) {
      return ''; 
    }
    const parts = dateString.split('/');
    if (parts.length === 3) {
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1; 
      const year = parseInt(parts[2], 10);
      return new Date(year, month, day);
    }
    return dateString;
  }
}
